"use strict";

import React from 'react';
import VideoPlayer from "../../components/VideoPlayer";

import { ProgressBar } from 'react-bootstrap';

import './FileUploader.less';

class FileUploader extends React.Component {
  constructor(props) {
    super(props);

    this.state= {
      uploadIcon: false
    };

    this._handleMouseEnter = this._handleMouseEnter.bind(this);
    this._handleMouseLeave = this._handleMouseLeave.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._handleFileChange = this._handleFileChange.bind(this);
  };
  static propTypes = {
    size: React.PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),

    fileType: React.PropTypes.oneOf(['image', 'video']),
    src: React.PropTypes.string,
    onChange: React.PropTypes.func,
    progress: React.PropTypes.number,
    selected: React.PropTypes.object,
    wrapperClass: React.PropTypes.string
  };
  componentWillUnmount(){
    let element = document.querySelector('#hostPic');
    if (element) {
      element.setAttribute('src', '');
    }
  }
  render() {
    const { size, src, wrapperClass, progress, selected, fileType,hideTracker } = this.props;
    const { uploadIcon } = this.state;
    let fileAccept, showFile = '';
  
    switch(fileType) {
      case 'image':
        fileAccept = "image/png,image/gif,image/jpeg";
        src
          ? showFile =
            <figure >
              <img id="hostPic" src={src} />
            </figure>
          : '';
        break;
      case 'video':
        fileAccept = 'video/*';
        src
          ? showFile =
            <VideoPlayer ref={i=>this.video=i}
                         url={src} />
            // <video controls autoPlay height="200">
            //   <source src="http://clips.vorwaerts-gmbh.de/VfE_html5.mp4" type="video/mp4">
            //   </source>
            // </video>
          : '';
    }
    const editFileJSX = <button type="button" className="btn btn-info upload-btn w-200"
                                onClick={()=>{ 
                                  this._handleClick();
                                  } } >Edit uploaded file
    </button>;

    const uploadFileJSX = jsx => {
      return(
        <div className="col-xs-12 pa0">
        <div className={ wrapperClass ? `${wrapperClass} img-box` : "img-box" }
             onMouseEnter={ this._handleMouseEnter }
             onMouseLeave={ this._handleMouseLeave }
             onClick={ this._handleClick } >
          <div className={`${size}-img`}>
            {jsx()}
            {
              uploadIcon ?
                <div className="upload-icon">
                  <div className={ size === 'large' ? 'fa fa-2x fa-upload' : 'fa fa-upload' }/>
                </div>
                :
                null
            }
          </div>
          {jsx()}
        </div>
        </div>
      )
    };

    const tracker = ()=>{      
      return (
        hideTracker ? null : <span>
        { selected ?
          <label>{selected.name}</label> :
          null
        }

        { progress?
            <ProgressBar active now={ progress }/> :
            null
        }
      </span>
    )};

    return(
      <div>
        { showFile }

        { showFile
          ? <div>
              { editFileJSX }
              {tracker()}
            </div>
          : <div>
          
              { uploadFileJSX (tracker) }
              { editFileJSX }
            </div>
        }

        <input type="file"
                 className="hidden"
                 accept={fileAccept}
                 ref={ fileInput => { this.fileInput = fileInput }}
                 onChange={ this._handleFileChange } />
      </div>
    )
  };

  _handleMouseEnter() {
    this.setState({ uploadIcon: true });
  };

  _handleMouseLeave() {
    this.setState({ uploadIcon: false });
  };

  _handleClick() {
    // check if user is a pending user or not
    const { user } = this.props;
    // console.log("user ---->", user)
    if(user && user.type === "pendingUser") {
      this.props.showVerifyEmailMessage();
    }
    else {
      this.fileInput.click();
    }
  };

  _handleFileChange(e) {
    const file = e.target.files[0];

    this.props.onChange(file);
  };

  autoplay = (from) => {
    this.video.autoplay(from);
  }
}

FileUploader.defaultProps = {
  size: 'medium',
  fileType: 'image'
};

export default FileUploader;
